<template>
    <div>
        <section class="w-full bg-blue-100">
            <div class="bg-white rounded-b-2xl">
                <div class="self-gutter">
                    <div class="self-gutter-y self-content">
                        <h1 class="title-2xl">{{ $t('my_favorites') }}</h1>
                    </div>
                </div>
            </div>
        </section>
        <article>
            <section class="bg-blue-100 self-gutter-y">
                <div class="self-gutter">
                    <div class="self-content">
                        <div class="flex flex-wrap w-full md:flex-nowrap">
                        </div>
                    </div>
                </div>
            </section>
        </article>
        <BestOffersBlock title="Minu lemmikud pakkumised" :web-content="$store.getters.getWebContents.favourites.join('')"/>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import BestOffersBlock from '../components/BestOffersBlock.vue'

@Component({
    components: {
        BestOffersBlock
    }
})
export default class MyFavourites extends Vue {
}
</script>

<style scoped>

</style>
